// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3VD0j","ring":"style_ring__1hh4O","lds-ring":"style_lds-ring__lrqJ4"};